// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2658":"19775854","5941":"288d2163"}[chunkId] + ".chunk.css";
};